import { render, staticRenderFns } from "./TopPicks.vue?vue&type=template&id=2be50ee6&scoped=true&"
import script from "./TopPicks.vue?vue&type=script&lang=js&"
export * from "./TopPicks.vue?vue&type=script&lang=js&"
import style0 from "./TopPicks.vue?vue&type=style&index=0&id=2be50ee6&prod&scoped=true&lang=css&"
import style1 from "./TopPicks.vue?vue&type=style&index=1&id=2be50ee6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be50ee6",
  null
  
)

export default component.exports